import React from 'react';

/* Icon set for the use-case card meta row + source chips — exact SVGs
 * exported from Figma node 30739-126461. */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var ScenarioIcon = function ScenarioIcon() {
  return /*#__PURE__*/_jsx("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    children: /*#__PURE__*/_jsx("path", {
      d: "M2 4.5H6C6.53043 4.5 7.03914 4.71071 7.41421 5.08579C7.78929 5.46086 8 5.96957 8 6.5V9.5C8 10.0304 8.21071 10.5391 8.58579 10.9142C8.96086 11.2893 9.46957 11.5 10 11.5H14M4 6L2 4.5L4 3M12 13L14 11.5L12 10",
      stroke: "#6E7781",
      strokeWidth: "1.4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
export var CriteriaIcon = function CriteriaIcon() {
  return /*#__PURE__*/_jsx("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    children: /*#__PURE__*/_jsx("path", {
      d: "M2 3.5L3 4.5L4.5 3M2 8L3 9L4.5 7.5M2 12.5L3 13.5L4.5 12M6.5 4H13.5M6.5 8.25H13.5M6.5 12.5H11",
      stroke: "#6E7781",
      strokeWidth: "1.4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
export var InvariantIcon = function InvariantIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M8 1.5L13.5 3.5V8C13.5 11 11 13.5 8 14.5C5 13.5 2.5 11 2.5 8V3.5L8 1.5Z",
      stroke: "#6E7781",
      strokeWidth: "1.4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.75 7.75L7.25 9.25L10.25 6.25",
      stroke: "#6E7781",
      strokeWidth: "1.4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
export var PdfFileIcon = function PdfFileIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    "aria-hidden": "true",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M1.73684 9.81476H0.947368L1.73684 10.6042V9.81476Z",
      fill: "#9A0E0E"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10.3578 9.81476H11.1473L10.3578 10.6042V9.81476Z",
      fill: "#9A0E0E"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2.66576 0.503289H8.13548L10.2595 2.85973V10.4486C10.2595 10.7034 10.1681 10.9447 10.0105 11.1195C9.85355 11.2935 9.64497 11.387 9.43236 11.3871H2.66576C2.45313 11.387 2.24458 11.2935 2.08763 11.1195C1.93003 10.9447 1.83861 10.7034 1.83861 10.4486V1.44177C1.83861 1.18698 1.93002 0.945709 2.08763 0.770868C2.24459 0.596816 2.4531 0.503364 2.66576 0.503289Z",
      fill: "#FFF5F5",
      stroke: "#D92D20",
      strokeWidth: "0.375"
    }), /*#__PURE__*/_jsx("path", {
      d: "M0.947368 5.94513H11.1505V9.81529H0.947368V5.94513Z",
      fill: "#B42318"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.62379 8.87805V7.425L7.46984 7.40079C7.43639 7.39387 7.40929 7.38233 7.38853 7.36619C7.36893 7.34889 7.35913 7.32467 7.35913 7.29354V7.11882H7.62379V6.98736C7.62379 6.88587 7.63878 6.79477 7.66876 6.71405C7.6999 6.63332 7.74372 6.5647 7.80023 6.5082C7.85789 6.45169 7.92766 6.40844 8.00954 6.37846C8.09142 6.34848 8.18368 6.33348 8.28631 6.33348C8.36819 6.33348 8.4443 6.34444 8.51465 6.36635L8.506 6.58085C8.50485 6.59699 8.50023 6.61026 8.49216 6.62063C8.48409 6.62986 8.47313 6.63736 8.45929 6.64312C8.44661 6.64774 8.43162 6.65119 8.41432 6.6535C8.39702 6.65465 8.37857 6.65523 8.35896 6.65523C8.30822 6.65523 8.26267 6.661 8.22231 6.67253C8.1831 6.68291 8.14966 6.70194 8.12198 6.72961C8.0943 6.75614 8.07297 6.79189 8.05798 6.83686C8.04414 6.88068 8.03722 6.93546 8.03722 7.0012V7.11882H8.49908V7.42327H8.05106V8.87805H7.62379Z",
      fill: "#fff"
    }), /*#__PURE__*/_jsx("path", {
      d: "M6.6503 7.55644C6.60186 7.49762 6.54881 7.45611 6.49115 7.43189C6.43464 7.40767 6.37352 7.39556 6.30779 7.39556C6.24321 7.39556 6.18497 7.40767 6.13308 7.43189C6.08118 7.45611 6.03678 7.49301 5.99988 7.5426C5.96298 7.59103 5.93472 7.65331 5.91512 7.72942C5.89552 7.80438 5.88571 7.89317 5.88571 7.99581C5.88571 8.0996 5.89379 8.18782 5.90993 8.26047C5.92723 8.33197 5.95145 8.39079 5.98258 8.43692C6.01372 8.48189 6.05178 8.51476 6.09675 8.53552C6.14173 8.55512 6.19189 8.56492 6.24725 8.56492C6.33604 8.56492 6.41158 8.54647 6.47385 8.50957C6.53613 8.47267 6.59494 8.42019 6.6503 8.35215V7.55644ZM7.07756 6.3075V8.87802H6.81636C6.75985 8.87802 6.7241 8.85207 6.70911 8.80018L6.67278 8.62893C6.60128 8.7108 6.51883 8.77711 6.42542 8.82786C6.33316 8.8786 6.22534 8.90397 6.10194 8.90397C6.00507 8.90397 5.91627 8.88379 5.83555 8.84342C5.75482 8.80306 5.68505 8.74482 5.62624 8.66871C5.56858 8.59145 5.5236 8.49631 5.49131 8.38329C5.46018 8.27028 5.44461 8.14112 5.44461 7.99581C5.44461 7.86434 5.46248 7.7421 5.49823 7.62909C5.53398 7.51607 5.5853 7.41805 5.65219 7.33502C5.71907 7.25199 5.79922 7.18741 5.89263 7.14128C5.98604 7.094 6.09099 7.07035 6.20746 7.07035C6.30664 7.07035 6.3914 7.08592 6.46174 7.11706C6.53209 7.1482 6.59494 7.19029 6.6503 7.24334V6.3075H7.07756Z",
      fill: "#fff"
    }), /*#__PURE__*/_jsx("path", {
      d: "M3.99727 8.41788C4.0457 8.47669 4.09817 8.51821 4.15468 8.54243C4.21234 8.56664 4.27462 8.57875 4.3415 8.57875C4.40608 8.57875 4.46432 8.56664 4.51621 8.54243C4.56811 8.51821 4.61193 8.48131 4.64768 8.43172C4.68458 8.38213 4.71284 8.31986 4.73244 8.2449C4.75205 8.16878 4.76185 8.07941 4.76185 7.97677C4.76185 7.87298 4.7532 7.78534 4.7359 7.71384C4.71976 7.64119 4.69612 7.58237 4.66498 7.5374C4.63384 7.49242 4.59579 7.45956 4.55081 7.4388C4.50699 7.41804 4.45682 7.40766 4.40032 7.40766C4.31152 7.40766 4.23598 7.42669 4.17371 7.46475C4.11143 7.50165 4.05262 7.55412 3.99727 7.62216V8.41788ZM3.97478 7.34539C4.04743 7.26351 4.12989 7.1972 4.22214 7.14646C4.3144 7.09572 4.4228 7.07035 4.54735 7.07035C4.64422 7.07035 4.73244 7.09053 4.81201 7.13089C4.89274 7.17125 4.96193 7.23007 5.01959 7.30733C5.07841 7.38344 5.12338 7.47801 5.15452 7.59102C5.18681 7.70289 5.20295 7.83147 5.20295 7.97677C5.20295 8.10939 5.18508 8.23221 5.14933 8.34523C5.11358 8.45824 5.06226 8.55626 4.99537 8.6393C4.92964 8.72233 4.84949 8.78748 4.75493 8.83477C4.66152 8.8809 4.55658 8.90396 4.4401 8.90396C4.34092 8.90396 4.25616 8.88897 4.18582 8.85898C4.11547 8.82785 4.05262 8.78518 3.99727 8.73098V9.4575H3.57V7.10321H3.8312C3.88656 7.10321 3.92288 7.12916 3.94018 7.18106L3.97478 7.34539Z",
      fill: "#fff"
    })]
  });
};
export var JiraSourceIcon = function JiraSourceIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    "aria-hidden": "true",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.52849 5.70223C3.45657 5.60966 3.34078 5.5608 3.2231 5.57338C3.10538 5.58595 3.00298 5.65818 2.95296 5.76383L0.0367892 11.5034C-0.0172222 11.6097 -0.0114508 11.736 0.052052 11.8371C0.115555 11.9383 0.227726 11.9999 0.348521 11.9999H4.40915C4.54199 12.0029 4.66422 11.9286 4.72087 11.8102C5.5968 10.0285 5.06589 7.31932 3.52849 5.70223Z",
      fill: "url(#ev-jira-grad)"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.5684 0.188814C4.042 2.48487 3.86583 5.39726 5.10475 7.85314L7.12623 11.8055C7.18715 11.9247 7.31177 12 7.44806 12H11.6401C11.7649 12 11.8807 11.9369 11.9462 11.8331C12.0118 11.7294 12.0178 11.5999 11.962 11.4909C11.962 11.4909 6.32229 0.462454 6.18052 0.186608C6.12332 0.0720366 6.00417 -0.000466314 5.87377 2.25765e-06C5.74337 0.000482258 5.62475 0.0738308 5.5684 0.188814Z",
      fill: "#2684FF"
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsxs("linearGradient", {
        id: "ev-jira-grad",
        x1: "11.9621",
        y1: "1.89772",
        x2: "4.78129",
        y2: "11.6926",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#0052CC"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.923",
          stopColor: "#2684FF"
        })]
      })
    })]
  });
};
export var DocFileIcon = function DocFileIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "10",
    height: "11.5",
    viewBox: "0 0 9.9375 11.4375",
    fill: "none",
    "aria-hidden": "true",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M9.01875 10.9688H0.91875C0.914816 10.9688 0.910653 10.9688 0.906279 10.9688C0.664654 10.9688 0.46875 10.7729 0.46875 10.5312V0.90625C0.46875 0.664625 0.664654 0.46875 0.906279 0.46875C0.910652 0.46875 0.914816 0.46875 0.91875 0.46875H6.61651C6.71413 0.46875 6.80791 0.506823 6.87791 0.574877L9.24156 2.87287C9.3868 3.01408 9.46875 3.20804 9.46875 3.41062V10.5312C9.46875 10.7729 9.27285 10.9688 9.03122 10.9688C9.02685 10.9688 9.02268 10.9688 9.01875 10.9688Z",
      stroke: "#6E7781",
      strokeWidth: "0.9375",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M6.09377 1.21875V3.46875C6.09377 3.67586 6.26166 3.84375 6.46877 3.84375H8.71877",
      stroke: "#6E7781",
      strokeWidth: "0.9375",
      strokeLinecap: "square"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2.71873 6.46875H7.21873",
      stroke: "#6E7781",
      strokeWidth: "0.9375",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2.71873 8.71875H7.21873",
      stroke: "#6E7781",
      strokeWidth: "0.9375",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};

/** Chip glyph per source: pdf by media type; the Figma marks Jira-born
 * sources with the Atlassian mark — packs carry no source-system field,
 * so an id prefixed "jira" is the only available signal; docs otherwise. */
export function SourceGlyph(_ref) {
  var id = _ref.id,
    mediaType = _ref.mediaType;
  if (mediaType === 'application/pdf') return /*#__PURE__*/_jsx(PdfFileIcon, {});
  if (id.toLowerCase().startsWith('jira')) return /*#__PURE__*/_jsx(JiraSourceIcon, {});
  return /*#__PURE__*/_jsx(DocFileIcon, {});
}